// extracted by mini-css-extract-plugin
var _1 = "SearchFacet-module__container--EklKO";
var _2 = "SearchFacet-module__isSelected--hDjt8";
export { _1 as "container", _2 as "isSelected" }
